export const JOB_LIST = "job_list"
export const JOB_LIST_SUCCESSFUL = "job_list_successfull"
export const JOB_LIST_FAILED = "job_list_failed"
// search candidate list
export const JOB_SEARCH_SUCCESSFUL = "job_list_successfull"
export const JOB_SEARCH_FAILED = "job_list_failed"
export const JOB_SEARCH = "job_search_list"

//job status
export const GET_JOB_STATUS = "GET_JOB_STATUS"
export const GET_JOB_STATUS_SUCCESSFUL = "GET_JOB_STATUS_SUCCESSFUL"
export const GET_JOB_STATUS_FAILED = "GET_JOB_STATUS_FAIL"

//jobDistribution
export const JOB_DISTRIBUTION = "JOB_DISTRIBUTION"
export const JOB_DISTRIBUTION_SUCCESSFUL = "JOB_DISTRIBUTION_SUCCESSFUL"
export const JOB_DISTRIBUTION_FAILED = "JOB_DISTRIBUTION_FAILED"

//mange

export const GET_MANAGE_LINK = "GET_MANAGE_LINK"
export const GET_MANGE_LINK_SUCCESS = "GET_MANGE_LINK_SUCCESS"
export const GET_MANGE_LINK_FAIL = "GET_MANGE_LINK_FAIL"


//Delete Job
export const JOB_DELETE = "job_delete"
export const JOB_DELETE_SUCCESSFUL = "job_delete_successfull"
export const JOB_DELETE_FAILED = "job_delete_failed"

export const GET_DATA = "get_data"
export const GET_SEARCH_DATA = "get_search_data"

//get jobs by search,list and filter
export const GET_JOBS_BY_SEARCH="GET_JOBS_BY_SEARCH"
export const GET_JOBS_BY_SEARCH_SUCCESS="GET_JOBS_BY_SEARCH_SUCCESS"
export const GET_JOBS_BY_SEARCH_FAILED="GET_JOBS_BY_SEARCH_FAILED"

export const GET_JOBS_BY_FILTER="GET_JOBS_BY_FILTER"
export const GET_JOBS_BY_FILTER_SUCCESS="GET_JOBS_BY_FILTER_SUCCESS"
export const GET_JOBS_BY_FILTER_FAILED="GET_JOBS_BY_FILTER_FAILED"

export const GET_JOBS_BY_LIST="GET_JOBS_BY_LIST"
export const GET_JOBS_BY_LIST_SUCCESS="GET_JOBS_BY_LIST_SUCCESS"
export const GET_JOBS_BY_LIST_FAILED="GET_JOBS_BY_LIST_FAILED"
